import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as actionTypes from './actionTypes';
import moment from 'moment';

export const dispatchProviderFrozenComplete = (data) => ({
  type: actionTypes.GET_PROVIDER_FROZEN_COMPLETE,
  payload: data,
});
export const dispatchNdcGridDetail = (data) => ({
  type: actionTypes.GET_NDC_GRID_DETAIL,
  payload: data,
});
export const dispatchReviewCorrectionDropdown = (data) => ({
  type: actionTypes.GET_CORRECTION_CODE_DROPDOWN,
  payload: data,
});
export const dispatchReviewProblemDropdown = (data) => ({
  type: actionTypes.GET_PROBLEM_CODE_DROPDOWN,
  payload: data,
});
export const dispatchProviderReviewClaimHeader = (data) => ({
  type: actionTypes.GET_PROVIDER_REVIEW_CLAIM_HEADER,
  payload: data,
});
export const dispatchProviderList = (data) => ({
  type: actionTypes.GET_PROVIDER_LIST,
  payload: data,
});
export const dispatchGetProviderDropDown = (data) => ({
  type: actionTypes.GET_PROVIDER_DROPDOWN,
  payload: data,
});
export const dispatchGetCommonData = (data) => ({
  type: actionTypes.GET_COMMON_DATA,
  payload: data,
});
export const dispatchGetDetailData = (data) => ({
  type: actionTypes.GET_DETAIL_DATA,
  payload: data,
});

export const dispatchGetProvider = (data) => ({
  type: actionTypes.GET_PROVIDER_DATA,
  payload: data,
});

export const setSelectTableData = (data) => {
  return {
    type: actionTypes.SELECT_TABLE_DATA,
    payload: data,
  };
};
export const dispatchBottonState = (data) => {
  return {
    type: actionTypes.BUTTON_STATE,
    payload: data,
  };
};
export const dispatchProblemCode = (data) => {
  return {
    type: actionTypes.GET_PROBLEMCODE,
    payload: data,
  };
};
export const dispatchcorrectionCode = (data) => {
  return {
    type: actionTypes.GET_CORRECTIONCODE,
    payload: data,
  };
};

export const handleErrorMessages = (data) => ({
  type: actionTypes.HANDLE_ERROR_MSG,
  errorMessagesInRedux: data,
});
export const disRowSelected = (val) => {
  return {
    type: actionTypes.ROW_SELECTED,
    rowSelected: val,
  };
};
export const getProvider = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PROVIDER, value)
    .then((response) => {
      return dispatch(dispatchGetProvider(response.data));
    })
    .catch(() => {
      dispatch(dispatchGetProvider([]));
    });
};

export const getProviderDropDown = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_REFERENCE_DATA, value)
    .then((response) => {
      return response.data;
    })
    .catch((response) => {
      return [];
    });
};

export const getNdcMainGridDetail = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_NDC_MAINGRID_DETAIL, value)
    .then((response) => {
      return dispatch(dispatchNdcGridDetail(response.data));
    })
    .catch(() => {
      dispatch(dispatchNdcGridDetail({ error: 'API failed' }));
    });
};

export const updateProviderFrozenComplete = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_PROVIDER_FROZEN_COMPLETE, value)
    .then((response) => {
      return dispatch(dispatchProviderFrozenComplete(response.data));
    })
    .catch(() => {
      dispatch(dispatchProviderFrozenComplete([]));
    });
};

export const getReviewCorrectionDropdown = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_REFERENCE_DATA, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};

export const getReviewProblemDropdown = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_REFERENCE_DATA, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};

// 1st page table double click API
export const FETCHALLPROVIDERLIST = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PROVIDER_RECORD_HEADER, value)
    .then((response) => {
      if (response?.data?.providerRecordDetailsHeader?.length > 0) {
        handleExistingCommentList(
          response?.data?.providerRecordDetailsHeader,
          'formLevel',
          dispatch
        );
      } else {
        return dispatch(dispatchProviderList([]));
      }
    })
    .catch(() => {
      dispatch(dispatchProviderList([]));
    });
};

// 2nd Screen Footer Table
export const getProviderReviewClaimHeader = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PROVIDER_REVIEW_CLAIM_HEADER, value)
    .then((response) => {
      if (
        response.data &&
        response?.data?.providerReviewClaimHeader?.length > 0
      ) {
        handleExistingCommentList(
          response?.data?.providerReviewClaimHeader,
          'gridLevel',
          dispatch
        );
      } else {
        dispatch(dispatchProviderReviewClaimHeader([]));
      }
    })
    .catch(() => {
      dispatch(dispatchProviderReviewClaimHeader([]));
    });
};

// set comment icon on if corrLinkId and comment is available
const handleExistingCommentList = async (data, name, dispatch) => {
  if (data && data?.length > 0) {
    const result = await getExistingCorrLinkIds({
      corrLinkId: data.map((item) => {
        return item.corrLinkId;
      }),
    });
    const tempObj = data?.map((item) => {
      if (
        result &&
        result.data?.filter((x) => {
          return x === item.corrLinkId;
        }).length > 0
      ) {
        item.ccCommentsExist = 1;
        item.numOfUnits = item.numOfUnits
          ? parseFloat(item.numOfUnits).toFixed(4)
          : 0.0;
        item.origNumOfUnits = item.origNumOfUnits
          ? parseFloat(item.origNumOfUnits).toFixed(4)
          : 0.0;
        item.serviceDt = item.serviceDt
          ? moment(item.serviceDt).format('MM/DD/YYYY')
          : '';
        item.paidDt = item.paidDt
          ? moment(item.paidDt).format('MM/DD/YYYY')
          : '';
      } else {
        item.ccCommentsExist = 0;
        item.numOfUnits = item.numOfUnits
          ? parseFloat(item.numOfUnits).toFixed(4)
          : 0.0;
        item.origNumOfUnits = item.origNumOfUnits
          ? parseFloat(item.origNumOfUnits).toFixed(4)
          : 0.0;
        item.serviceDt = item.serviceDt
          ? moment(item.serviceDt).format('MM/DD/YYYY')
          : '';
        item.paidDt = item.paidDt
          ? moment(item.paidDt).format('MM/DD/YYYY')
          : '';
      }
      return item;
    });
    if (name === 'gridLevel') {
      return dispatch(dispatchProviderReviewClaimHeader(tempObj));
    }
    if (name === 'formLevel') {
      return dispatch(dispatchProviderList(tempObj));
    }
  }
};

export const getExistingCorrLinkIds = (value) => {
  return axios
    .post(serviceEndPoint.GET_EXISTING_COMMENT_LINK_IDS, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};
export const clearReduxProviderReviewSecondScreen = () => (dispatch) => {
  dispatch(dispatchReviewProblemDropdown({}));
  dispatch(dispatchReviewCorrectionDropdown({}));
  dispatch(dispatchGetDetailData({}));
  dispatch(setSelectTableData({}));
  dispatch(dispatchNdcGridDetail([]));
  dispatch(dispatchProviderReviewClaimHeader([]));
  dispatch(dispatchProviderFrozenComplete(''));
  dispatch(handleErrorMessages({}));
  dispatch(dispatchProblemCode(''));
  dispatch(dispatchcorrectionCode(''));
  dispatch(dispatchGetProviderDropDown({}));
  dispatch(dispatchBottonState(''));
};
